import i18next from 'i18next';

import { appStore } from '../../../stores/AppStore';
import { formatDate } from '../../../utils/dialogUtils';

export const useValidUntil = () => {
    const { urlInfo } = appStore.useState(['embed', 'urlInfo']);

    if (urlInfo?.validUntil == null) {
        return false;
    }

    const validUntil: string = urlInfo?.validUntil ? formatDate(urlInfo.validUntil, i18next.language) : '';
    return validUntil;
};
